module.exports = __webpack_public_path__ + "img/partner_8.0cac15a8.png";